const lightColors = {
  primary: '#f25e37',
  secondary: '#ef790f',
  primaryHover: 'rgb(232, 76, 32)',
  primaryLight: 'rgba(94, 0, 17, .1)',
  primarySoft: 'rgba(94, 0, 17, .4)',
  darkPrimary: '#322e6f',
  softGray: '#f6f6f6',
  lightGray: '#3a3b3d',
  gray: '#8f8f91',
  darkGray: '#2a2a2f',
  opaqueText: '#8f8f91',
  white: 'white',
  red: '#780116',
  redSoft: 'rgba(227, 79, 47, .1)',
  redHover: '#9e3a24',
  transparent: 'transparent',
  contrast: 'white',
  shadow: 'rgba(0, 0, 0, 0.24)',
  background: '#f1f0f5',
  card: 'white',
  darker: '#1d2024',
  gradient: 'rgba(50, 46, 111, .6)',
  secondaryGradient: 'rgba(253, 186, 29, .4)',
  border: 'rgba(0, 0, 0, .4)',
  softBorder: 'rgba(128, 128, 128, .2)',
  error: 'red',
  success: 'rgb(0, 104, 74)',
  info: '#228be6',
  inputBorder: 'rgba(128, 128, 128, .6)',
  text: 'black',
  opacityText: 'rgba(0, 0, 0, .7)',
  invertedText: 'white',
  green: 'rgb(0, 104, 74)',
  softBackground: '#f2f2f2',

  table: {
    row: 'white',
    rowHover: 'rgba(0, 48, 130, 0.1)',
    header: '#f6f6f6',
    border: 'rgba(128, 128, 128, .4)',
  },
};

const darkColors = {
  primary: '#f25e37',
  secondary: '#ef790f',
  primaryHover: '#f75d34',
  primaryLight: 'rgba(94, 0, 17, .1)',
  primarySoft: 'rgba(94, 0, 17, .4)',
  darkPrimary: '#322e6f',
  softGray: '#f6f6f6',
  lightGray: '#3a3b3d',
  gray: '#8f8f91',
  darkGray: '#2a2a2f',
  opaqueText: '#8f8f91',
  white: 'white',
  red: '#780116',
  redSoft: 'rgba(227, 79, 47, .1)',
  redHover: '#9e3a24',
  transparent: 'transparent',
  contrast: '#141414',
  shadow: 'rgba(0, 0, 0, 0.24)',
  background: 'black',
  card: '#141414',
  darker: '#1d2024',
  gradient: 'rgba(50, 46, 111, .6)',
  secondaryGradient: 'rgba(253, 186, 29, .4)',
  border: 'rgba(0, 0, 0, .4)',
  softBorder: 'rgba(128, 128, 128, .2)',
  success: 'rgb(0, 104, 74)',
  error: 'red',
  info: '#228be6',
  inputBorder: 'rgba(128, 128, 128, .6)',
  text: 'white',
  opacityText: 'rgba(255, 255, 255, .7)',
  invertedText: 'black',
  green: 'rgb(0, 104, 74)',
  softBackground: '#f2f2f2',

  table: {
    row: 'black',
    rowHover: 'rgba(128, 128, 128, 0.1)',
    header: '#141414',
    border: 'rgba(128, 128, 128, .4)',
  },
};

export {lightColors, darkColors};

// export default {
//   primary: '#f25e37',
//   secondary: '#ef790f',
//   primaryHover: '#f75d34',
//   primaryLight: 'rgba(94, 0, 17, .1)',
//   primarySoft: 'rgba(94, 0, 17, .4)',
//   darkPrimary: '#322e6f',
//   softGray: '#f6f6f6',
//   lightGray: '#3a3b3d',
//   gray: '#8f8f91',
//   darkGray: '#2a2a2f',
//   opaqueText: '#8f8f91',
//   white: 'white',
//   red: '#780116',
//   redSoft: 'rgba(227, 79, 47, .1)',
//   redHover: '#9e3a24',
//   transparent: 'transparent',
//   shadow: 'rgba(0, 0, 0, 0.24)',
//   background: 'black',
//   // card: '#262626',
//   card: '#1b1b1b',
//   darker: '#1d2024',
//   gradient: 'rgba(50, 46, 111, .6)',
//   secondaryGradient: 'rgba(253, 186, 29, .4)',
//   border: 'rgba(0, 0, 0, .4)',
//   softBorder: 'rgba(128, 128, 128, .2)',
//   success: 'rgb(0, 104, 74)',
//   info: '#228be6',
//   inputBorder: 'rgba(128, 128, 128, .6)',
// };
